import React from 'react';
import { createRoot } from 'react-dom/client';

import '@progress/kendo-ui';
import '@progress/kendo-ui/js/cultures/kendo.culture.sk-SK.js';
import App from './App';
import registerServiceWorker, { unregister } from './registerServiceWorker';
import { MetaProvider } from './coraWebComponents/utils/withMeta';

import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.min.css';
import './coraWebComponents/_index.scss';
import './index.scss';

import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';


import rootReducer from './reducers';
import logger from './coraWebComponents/utils/logger';


export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      serializableCheck: false,
    }).concat(logger),
  devTools: process.env.NODE_ENV !== 'production'
});

const root = createRoot(document.getElementById('root'));

root.render(
  <MetaProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </MetaProvider>
);

if (window.config.enableServiceWorker) {
  registerServiceWorker();
}
else {
  unregister();
}